module.exports = __webpack_public_path__ + "static/media/31.d15dfca9.svg";